/* eslint-disable camelcase -- backend wire-format field names */
import { getActiveAuth } from '../config/firebase'
import { API_BASE_URL } from '../config/api'

export interface HeardAboutAnswer {
  choice: string
  other_text?: string
}

const API_ROOT = API_BASE_URL.replace(/\/+$/, '')

async function post(path: string, body: unknown, withToken: boolean): Promise<void> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (withToken) {
    const token = await getActiveAuth().currentUser?.getIdToken()
    if (token) headers.Authorization = `Bearer ${token}`
  }
  const response = await fetch(`${API_ROOT}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  if (!response.ok) throw new Error(`heard-about failed: ${response.status}`)
}

/** Signed-in user answers "how did you find Livewello?" (writes once to their account). */
export function saveHeardAbout(answer: HeardAboutAnswer): Promise<void> {
  return post('/api/v1/auth/heard-about', answer, true)
}

/** Kit buyer answers from the purchase success page. Guests send no token. */
export function saveKitHeardAbout(sessionId: string, answer: HeardAboutAnswer): Promise<void> {
  return post('/api/dna-kits/heard-about', { session_id: sessionId, ...answer }, true)
}
